export default __webpack_public_path__ + "static/16-a8c9b1c8558e19c11c81c88df6f2ed18.png";